import React from 'react'
import frame from "../../assets/images/app.png"
import "./frame.css"

const Frame = () => {
  return (
    <div className='frame flex center p1 '>
        <p>Sign up and get 20% off to your first order. <span className='bold'>Sign Up Now</span></p>
    </div>
  )
}

export default Frame